import { useQuery } from "@tanstack/react-query"

import { api } from "@/api"
import { ENDPOINTS } from "@/constants"
export const getWebhookById = async (webhookId: string) => {
  const url = `${ENDPOINTS.WEBHOOKS}/${webhookId}`
  const { data } = await api.get<WebhookConfigurationType>(url)
  return data
}
const useWebhookById = (webhookId: string) => {
  return useQuery({
    queryKey: [ENDPOINTS.WEBHOOKS, webhookId],
    queryFn: () => getWebhookById(webhookId),
    enabled: !!webhookId,
  })
}
export default useWebhookById
